module.exports = __webpack_public_path__ + "static/media/second.6957bfcf.jpeg";